export default __webpack_public_path__ + "static/boulevard2-7735ebf7a58e82b2fbeba3c1b4ecc3eb.jpg";